import { render, staticRenderFns } from "./HistoryChart.vue?vue&type=template&id=f8b79526&scoped=true&"
import script from "./HistoryChart.vue?vue&type=script&lang=ts&"
export * from "./HistoryChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b79526",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VSheet,VSkeletonLoader,VSparkline})
